<template>
  <container :class="['page-wrapper', 'mb-8']">
    <flex :spacing="3" v-if="gradients.length">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="12" sm24 v-for="index in 6" :key="index">
        <card full-height>
          <card-actions align="center">
            <code-chunk :pre="false">{{ getColors(index) }}</code-chunk>
          </card-actions>
          <divider />
          <card-text>
            <lorem-ipsum :repeats="3" :class="['font-bold', 'uppercase']" v-gradient-text="getColors(index)" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageGradientText',
  mixins: [
    methods
  ],
  data () {
    return {
      gradients: []
    }
  },
  mounted () {
    this.getExternalData('gradient-text.json', 'gradients')
  },
  methods: {
    getColors (index) {
      return {
        tilt: 90,
        colors: this.gradients[index - 1]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/gradient-text.vue